import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from '../../contexts/translation';
import useUnsavedChangesWarning from '../../hooks/useUnsavedChangesWarning';
import { Columns } from '../../pages/Assets/Columns/AssetTabCycleColumns';
import { DocumentType } from '../../types/documentType.types';
import { Person } from '../../types/person.types';
import AssetCycleModal from '../modals/AssetCycleModal';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

export interface IAssetTabCycleDataGrid extends IDataGrid {
  onSelectionChanged?: (e: any) => void;
  isReadOnly?: boolean;
  canCreateTask: boolean;
  capacityCategories: any;
  documentTypes?: DocumentType[];
  persons?: Person[];
  handleNew: () => void;
  handleEdit: (e: any) => void;
  handleClose: () => void;
  modalVisibility: boolean;
  selectedData: any;
  selectedAction: any;
  onDataSubmit: (data: any, actionType: any) => void;
  createTaskFromAssetCycle?: (cycleId: number) => void;
  assetId?: number;
}

export const AssetTabCycleDataGrid = ({
  data,
  onSelectionChanged,
  isReadOnly,
  canCreateTask,
  capacityCategories,
  documentTypes,
  persons,
  handleNew,
  handleEdit,
  handleClose,
  modalVisibility,
  selectedData,
  selectedAction,
  onDataSubmit,
  createTaskFromAssetCycle,
  assetId,
}: IAssetTabCycleDataGrid) => {
  const { translate } = useTranslation();
  const history = useHistory();
  const transFormName = 'Asset.Cycle';

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        html: translate!('Asset cycles', transFormName),
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          type: 'default',
          stylingMode: 'contained',
          onClick: handleNew,
          visible: !isReadOnly,
        },
      },
    );
  };

  const { pathname } = useLocation();
  const [Prompt, setDirty, setClean] = useUnsavedChangesWarning(pathname);

  console.log('canCreateTask', canCreateTask);

  return (
    <>
      <SisDataGrid
        data={data}
        keyExpr={'id'}
        selection={{ mode: 'single' }}
        transFormName={transFormName}
        columns={Columns(
          isReadOnly,
          handleEdit,
          translate,
          createTaskFromAssetCycle,
          history,
          assetId,
          canCreateTask,
        )}
        onSelectionChanged={onSelectionChanged}
        onToolbarPreparing={onToolbarPreparing}
        columnChooser={false}
        allowColumnResizing={false}
        allowColumnReordering={false}
        isReadOnly={isReadOnly ?? false}
        prompt={Prompt}
      />
      {modalVisibility && (
        <AssetCycleModal
          isVisible={modalVisibility}
          data={selectedData ?? null}
          actionType={selectedAction}
          capacityCategories={capacityCategories}
          documentTypes={documentTypes}
          persons={persons}
          transFormName={transFormName}
          onSubmit={onDataSubmit}
          onClose={handleClose}
        />
      )}
    </>
  );
};
